
import axios from "axios";

// Hosts considerados desarrollo (apuntan al backend local).
const DEV_HOSTS = ['localhost', '127.0.0.1'];

const api = axios.create({
  // Permite forzar el backend con VITE_API_BASE_URL (p.ej. en staging/preview, para
  // NO pegar a producción). Si no, local en dev y api.wayoai.app en el resto.
  baseURL:
    (import.meta.env && import.meta.env.VITE_API_BASE_URL) ||
    (DEV_HOSTS.includes(window.location.hostname)
      ? 'http://127.0.0.1:8000/api'
      : 'https://api.wayoai.app/api'),
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // o sessionStorage si prefieres
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
